var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalentChallenge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_361_52)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6584 16.487C32.4315 6.00171 44.5715 -0.749393 58.2131 -0.75C58.7499 -0.750024 59.2647 -0.526151 59.6442 -0.127634C60.0238 0.270884 60.237 0.811399 60.237 1.375C60.237 15.6993 53.8074 28.4475 43.8211 36.6099C43.9695 37.5931 44.0465 38.6002 44.0465 39.625C44.0465 50.1874 35.8917 58.75 25.8322 58.75C24.7145 58.75 23.8084 57.7986 23.8084 56.625V44.919C23.7834 44.9001 23.7588 44.8805 23.7346 44.8603C21.1657 42.7215 18.8379 40.2774 16.8009 37.58C16.7811 37.5538 16.7619 37.5271 16.7434 37.5H5.59412C4.4764 37.5 3.57031 36.5486 3.57031 35.375C3.57031 24.8126 11.7251 16.25 21.7846 16.25C22.7614 16.25 23.7213 16.3309 24.6584 16.487ZM39.9989 14.125C36.6457 14.125 33.9275 16.9792 33.9275 20.5C33.9275 24.0208 36.6457 26.875 39.9989 26.875C43.352 26.875 46.0703 24.0208 46.0703 20.5C46.0703 16.9792 43.352 14.125 39.9989 14.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7173 43.8518C14.6132 43.1501 14.7977 41.8186 14.1294 40.8779C13.461 39.9373 12.193 39.7435 11.2971 40.4453C7.83944 43.1536 5.59412 47.4892 5.59412 52.3748C5.59412 53.1555 5.65158 53.9236 5.76265 54.6742C5.89793 55.5885 6.58105 56.3058 7.45177 56.4478C8.16669 56.5644 8.89819 56.6248 9.64174 56.6248C14.2947 56.6248 18.4238 54.2672 21.0031 50.6366C21.6715 49.696 21.487 48.3645 20.5911 47.6628C19.6952 46.961 18.4271 47.1547 17.7588 48.0954C15.9105 50.6969 12.963 52.3748 9.64174 52.3748C9.64174 48.8875 11.2397 45.7925 13.7173 43.8518Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_361_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentChallenge);
export default __webpack_public_path__ + "static/media/talent-challenge.132b83c1363f6705b8649d0e5243fdc9.svg";
export { ForwardRef as ReactComponent };